import TopNavigation, {
  TopNavigationProps,
} from '@amzn/awsui-components-console/top-navigation';
import fusionLogo from '../assets/FusionMark.png';
import { useAuthState } from '../authentication/context';

export const AppTopNavigation = () => {
  const { isAuthenticated, userAlias } = useAuthState();

  // Mirror the Fusion Home user menu, but with FLC-specific feedback/support
  // links. Only shown once authenticated so we never render a nameless profile
  // menu while the app is still resolving the Cognito session.
  const utilities: TopNavigationProps.Utility[] =
    isAuthenticated && userAlias
      ? [
          {
            type: 'menu-dropdown',
            text: userAlias,
            iconName: 'user-profile',
            items: [
              {
                id: 'feedback-group',
                text: 'Feedback',
                items: [
                  {
                    id: 'feature-request',
                    text: 'FLC Feature Request',
                    href: 'https://t.corp.amazon.com/create/templates/e6611ddc-2e5a-4d49-96b7-92e16bc8767e',
                    external: true,
                    externalIconAriaLabel: ' (opens in new tab)',
                  },
                  {
                    id: 'report-bug',
                    text: 'FLC Bug Report',
                    href: 'https://t.corp.amazon.com/create/templates/1ca10da7-acd7-4ace-881b-91b7d295ef3b',
                    external: true,
                    externalIconAriaLabel: ' (opens in new tab)',
                  },
                ],
              },
              {
                id: 'support-group',
                text: 'Support',
                items: [
                  {
                    id: 'slack',
                    text: '#tcx-conferences Slack',
                    href: 'https://amazon.enterprise.slack.com/archives/G01B6BT0NF8',
                    external: true,
                    externalIconAriaLabel: ' (opens in new tab)',
                  },
                ],
              },
            ],
          },
        ]
      : [];

  return (
    <TopNavigation
      identity={{
        href: 'https://fusion.docs.aws.dev',
        logo: {
          src: fusionLogo,
          alt: 'Fusion',
        },
      }}
      utilities={utilities}
    />
  );
};
